import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import DynamicCard from '../../CustomComponents/DynamicHomeCard';
import { width } from '../../CustomComponents/Card/CardStyles';
import { addLineBreaks, clearStorageExceptKey } from '../../../utils';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { LogoContainer } from '../../Layout/Footer/FooterStyles';
import Logo from '../../../assets/images/home_logo.png';
import CustomAlertModel from '../../CustomComponents/CustomAlertModel';
import Arrow from '../../../assets/images/arrow.png';
import { store, persistor } from '../../../Redux/store';
import { useOidcAccessToken, useOidc, useOidcUser } from "@axa-fr/react-oidc";
import { GetApiHeadersWithBearer, GetApiHeadersWithOutBearer, PostRequest } from '../../../network/NetworkUtils';
import { appTheme, fetchConfigarationData, retrieveData } from '../../../helpers/utils/Utils';
import { CIP_STATUS, END_SESSION, GET_CIP_STATUS, STATUS_SUCCESS_CODE, UPDATE_CIP_STATUS } from '../../../network/URLConstants';
import Loader from '../../CustomComponents/Loader';
import CardHeading from '../../CustomComponents/CardHeading';

const appConfigData = await fetchConfigarationData();

const CipDocumentUploadScreen = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { logout, login } = useOidc();
    const { register } = useForm();
    const { t } = useTranslation();
    const [files, setFiles] = useState([]);
    const [progress, setProgress] = useState({});
    const [completedFiles, setCompletedFiles] = useState({});
    const [userDetails, setUserDetails] = useState({});
    const cipReferResponseData = useSelector(state => state.cipReferResponse);
    const personalInfo = useSelector(state => state.signUpPersonelInfo);
    const signUpMobileVal = useSelector(state => state.signUpMobile);
    const iframeRef = useRef(null);
    const iframeUrl = cipReferResponseData?.secureFormURL;
    const message = cipReferResponseData?.message;
    const messageHeader = cipReferResponseData?.messageHeader;
    const userId = useSelector(state => state.userId); // userId
    const [showModel, setShowModel] = useState(false);
    const [highlightMsg, setHighlightMsg] = useState("");
    const [headerMsg, setheaderMsg] = useState("");
    const [subHeaderMsg, setSubHeaderMsg] = useState("");
    const [btn1Exists, setBtn1Exists] = useState(false);
    const [btn2Exists, setBtn2Exists] = useState(false);
    const [btn1Text, setBtn1Text] = useState(false);
    const [btn2Text, setBtn2Text] = useState("");
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
    const [modelImage, setModelImage] = useState("");
    const isB2c = useSelector(state => state.preferredIdentity);

    const HighlightMsgStyles =
        "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
    const HeaderMsgStyles =
        "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
    const SubHeaderMsgStyles =
        "sm:w-auto w-[200px] font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-[500] cursor-pointer text-[var(--modal-text-heading-clr)]";
    const FailSubHeaderMsgStyles =
        "md:w-[317px] sm:w-[257px] text-[var(--modal-text-heading-clr)] font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer";
    const [isShowContinueButton, setIsShowContinueButton] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const accessTokenToApi = useSelector((state) => state.accessToken);


    const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
    const appThemeData = appTheme(signUpkudzuPlusTrue);


    var postMessageData = {};

    debugger;
    if (userId != undefined && userId != "" && userId != null) {
        postMessageData = {
            "variables": {
                "firstName": personalInfo?.firstName || "",
                "lastName": personalInfo?.lastName || "",
                "phoneNumber": signUpMobileVal || "",
                "PRN": cipReferResponseData?.prn || "",
                "customerEmail": personalInfo?.username || ""
            }
        };
    } else {
        postMessageData = {
            "variables": {
                "firstName": cipReferResponseData?.firstName,
                "lastName": cipReferResponseData?.lastName,
                "phoneNumber": cipReferResponseData?.mobile,
                "PRN": cipReferResponseData?.prn,
                "customerEmail": cipReferResponseData?.email
            }
        };
    }

    const handleIframeLoad = () => {
        if (iframeRef.current) {
            iframeRef.current.contentWindow.postMessage(postMessageData, "*");
        }
    };

    const handleSaveClick = useCallback(async () => {
        debugger;
        const deviceId = await retrieveData('updatedDeviceId');
        var headers;
        var object;
        if (userId == undefined || userId == "") {
            headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
            object = {}
        } else {
            object = { "ApplicationID": appConfigData.CLIENT_ID }
            headers = await GetApiHeadersWithOutBearer(deviceId);
        }
        setIsLoading(true);
        const cipUrl = userId ? UPDATE_CIP_STATUS(userId) : GET_CIP_STATUS;
        const response = await PostRequest(cipUrl, object, headers);
        let responseObj = JSON.parse(response);
        if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
            setIsLoading(false);
            console.log('CIP status updated successfully', responseObj);
            showAlertModal(
                true,
                t("thanks"),
                t("Additional_Document_Success_Text"),
                t("Additional_Document_Success_SubText"),
                true,
                false,
                t('ok'),
                "",
                true,
                signUpkudzuPlusTrue ? require('../../../assets/kudzu-plus-images/illo-pending-dark.png') :
                    require('../../../assets/images/file_pending.png')
            );
        } else {
            setIsLoading(false);
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("alert"), displayText, "", true, false, t('ok'), "", true, require('../../../assets/images/profileError.png'));

        }
    }, [userId, t]);

    const showAlertModal = (
        showModel,
        highlightMsg,
        headerMsg,
        subHeaderMsg,
        btn1Exists,
        btn2Exists,
        btn1Text,
        btn2Text,
        btn1TypeAcpt,
        modelImage
    ) => {
        setShowModel(showModel);
        setHighlightMsg(highlightMsg);
        setheaderMsg(headerMsg);
        setSubHeaderMsg(subHeaderMsg);
        setBtn1Exists(btn1Exists);
        setBtn2Exists(btn2Exists);
        setBtn1Text(btn1Text);
        setBtn2Text(btn2Text);
        setBtn1TypeAcpt(btn1TypeAcpt);
        setModelImage(modelImage);
    };

    const closeModel = () => {
        setShowModel(false)
        if (userId == undefined || userId == '' || accessTokenToApi == '') {
        } else {
            handleLogout()
        }

    }

    const onAcptBtnClick = async () => {
        debugger;
        setShowModel(false)
        if (userId == undefined || userId == '' || accessTokenToApi == '') {
            login("/")
        } else {
            handleLogout()
        }
    }

    const handleLogout = async () => {
        global.isLoggedIn = false
        await logout()
        logoutManually();
        const deviceIdKey = 'updatedDeviceId';
        clearStorageExceptKey(sessionStorage, deviceIdKey);
        clearStorageExceptKey(localStorage, deviceIdKey);
        store.dispatch({ type: 'LOGOUT' });
        const loginPayload = { isLoggedIn: false };
        dispatch({ type: 'LOG_IN', payload: loginPayload });

    }
    const logoutManually = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        var url = END_SESSION(isB2c, appConfigData.AUTH_URL, appConfigData.B2C_END_SESSION_URL, appConfigData.CLIENT_ID, accessTokenToApi, appConfigData.POST_LOGOUT_REDIRECT_URI);
        window.location.replace(url);
    }


    useEffect(() => {
        files.forEach((file) => {
            if (progress[file.name] >= 100 && !completedFiles[file.name]) {
                setTimeout(() => {
                    setCompletedFiles(prevState => ({
                        ...prevState,
                        [file.name]: true,
                    }));
                }, 1000);
            }
        });
    }, [files, progress, completedFiles]);

    return (
        <>
            <div className="sm:px-[6%] md:py-10 sm:py-12 sm:mt-0 sm:ml-0 ml-9 mt-8 flex flex-wrap sm:flex-nowrap scroll-mt-0">
                <LogoContainer>
                    <img src={Logo} className="md:h-[39px] w-[97px] h-[29px] md:w-[130px] cursor-pointer" alt="Kudzu Logo" />
                </LogoContainer>
            </div>
            <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">
                <div className='sm:mt-0 sm:ml-0 ml-6 mt-8'>
                    {files.length >= 2 ? (
                        <div className="text-[#94C3E8] font-normal  ml-3 mt-3  lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]  sm:leading-[30px] leading-[31px] font-serif-pro lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10 border-opacity-[50%]">
                            <p>{t("Welcome_back")}</p>
                            <p className='text-white'>{addLineBreaks(t("Little_More_Info"))}</p>
                        </div>
                    ) : (
                        <p className="text-white font-normal  ml-3 mt-3  lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]  sm:leading-[30px] leading-[31px] font-serif-pro lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10 border-opacity-[50%]">
                            {addLineBreaks(t(messageHeader))}
                        </p>
                    )}
                </div>
                <div className='md:w-[110px] sm:w-[60px] w-[0px]'></div>
                <div className='flex flex-col lg:w-[860px] md:w-[700px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight'>
                    <DynamicCard header={true} CardRadius={true} cardWidth={width.allpolicies} HeaderRadius={true}
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        backgroundColor={'--cardHeading-bg'}
                        HeaderContent={
                            <>
                                <CardHeading heading={t('Account_Verification')} />
                            </>
                        }

                    >
                        <div className={`${signUpkudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}
                        pb-10 sm:mx-0 mx-4`}></div>

                        {/* Adding the iframe */}
                        <div className="relative right-16.5 sm:w-[90%] w-[264px] sm:mx-0 mx-4">
                            <div className="font-serif-pro lg:text-[18px] md:text-[18px] sm:text-[16px] text-[14px] md:leading-[25px] sm:leading-[18px] leading-[22px] font-normal text-[#262B3A]">
                                <p className="mb-4 sm:mb-8 text-[var(--modal-text-heading-clr)] md:w-[508px] sm:w-[282px]">
                                    {message}
                                </p>
                                {/* iFrame with URL */}
                                {iframeUrl ? (
                                    <iframe src={iframeUrl}
                                        ref={iframeRef}
                                        title="secureURL" className="w-full min-h-[700px]"
                                        onLoad={handleIframeLoad}
                                    />
                                ) : (
                                    <p>{t("Iframe URL not available or failed to load.")}</p>
                                )}


                                <div className="flex mb-4 justify-between md:gap-14 sm:gap-8 py-12">
                                    <button
                                        type="button"
                                        className="font-hanken-grotesk sm:font-semibold font-[700]  lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]  text-[var(--modal-text-highlight)]  flex items-center"
                                        onClick={() => {
                                            debugger;
                                            if (accessTokenToApi == undefined || accessTokenToApi == null || accessTokenToApi == '') {
                                                navigate('/')
                                            } else {
                                                handleLogout()
                                            }
                                        }} >
                                        {t('add_later')}
                                    </button>
                                    {isShowContinueButton && <button
                                        type="button"
                                        className="font-hanken-grotesk sm:font-semibold font-[700]   lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]   text-[var(--transactions-filter-blue-text)] cursor-pointer flex items-center"
                                        onClick={() => { handleSaveClick() }}>
                                        {t('next')}<img
                                            src={appThemeData.arrowWhiteTwofac}
                                            className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                                            alt="Arrow" />
                                    </button>}

                                </div>


                            </div>
                        </div>
                    </DynamicCard>
                </div>
                <CustomAlertModel isOpen={showModel} onClose={closeModel} image={modelImage}
                    highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg} <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
                    subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                    btn1Exists={btn1Exists}
                    btn2Exists={btn2Exists}
                    btn1Text={btn1Text}
                    btn2Text={btn2Text}
                    btn1TypeAcpt={btn1TypeAcpt}
                    onAcptBtnClick={onAcptBtnClick}
                />
                {isLoading && <Loader />}
            </div>
        </>
    );
};

export default CipDocumentUploadScreen;